// app.slice.js
// 📍 Location: frontend/app.slice.js

import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isAuth: !!localStorage.getItem("token"),
  user: JSON.parse(localStorage.getItem("user")) || {},
  token: localStorage.getItem("token") || null,
};

export const appSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    login: (state, action) => {
      state.isAuth = true;
      state.token = action.payload.data.token;
      state.user = action.payload.data.user;
      
      localStorage.setItem("token", action.payload.data.token);
      localStorage.setItem("user", JSON.stringify(action.payload.data.user));
    },
    
    logout: (state) => {
      state.isAuth = false;
      state.token = null;
      state.user = {};
      
      localStorage.removeItem("token");
      localStorage.removeItem("user");
    },
    
    storeMe: (state, action) => {
      // Merge so partial /auth/profile responses don't wipe locationIds etc.
      state.user = { ...state.user, ...action.payload.data.user };
      localStorage.setItem("user", JSON.stringify(state.user));
    },
    
    // ✅ ADD THIS - setUser reducer
    setUser: (state, action) => {
      state.user = { ...state.user, ...action.payload };
      localStorage.setItem("user", JSON.stringify(state.user));
    },
    
    // ✅ ADD THIS - update token
    setToken: (state, action) => {
      state.token = action.payload;
      localStorage.setItem("token", action.payload);
    },
  },
});

export const { login, logout, storeMe, setUser, setToken } = appSlice.actions;

export default appSlice.reducer;